// extracted by mini-css-extract-plugin
export default {"pnl-history":"PNLHistoryPanel_pnl-history__+goqd"};